import { EntityId } from "@reduxjs/toolkit";

import { DateTime } from "luxon";

import { streamingApi } from "./base.api";
import { SiteEventType } from "types/SiteEventType";
import { SiteEvent } from "types/SiteEvent";

const BASE_PATH = "/site-events";

export const siteEventsApi = streamingApi.injectEndpoints({
    endpoints: (build) => ({
        // site data generic
        getSiteEvents: build.query<
            SiteEvent[],
            {
                siteId: EntityId;
                eventTypes: SiteEventType[];
            }
        >({
            query: (args) => {
                const startDateTime = DateTime.now()
                    .minus({ minutes: 5 })
                    .toUTC()
                    .toISO();
                const endDateTime = DateTime.now()
                    .plus({ minutes: 5 })
                    .toUTC()
                    .toISO();

                return {
                    url: `${BASE_PATH}/siteevents/sites/${args.siteId}/events/${args.eventTypes.join(",")}`,
                    params: { startDateTime, endDateTime },
                };
            },
        }),
    }),
    overrideExisting: true,
});

export const { useGetSiteEventsQuery } = siteEventsApi;
